import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: false
})
export class HomeComponent {

  useCases = [
    {
      title: 'Atención al cliente 24/7',
      description: 'Responde consultas frecuentes, resuelve dudas y proporciona soporte constante sin intervención humana.'
    },
    {
      title: 'Gestión de reservas y citas',
      description: 'Automatiza el proceso de reservas, reduce errores y ofrece confirmaciones instantáneas a tus clientes.'
    },
    {
      title: 'Asistente de capacitación',
      description: 'Complementa tus programas de formación con un asistente virtual que resuelve dudas y refuerza conocimientos.'
    }
  ];

}
